import { buildService } from '@rd-web-markets/shared/dist/services/service';
import serviceMethods from '@rd-web-markets/shared/dist/services/service_methods';
import { useCallback } from 'react';
import { replaceInArray } from '@rd-web-markets/shared/dist/util/arrayUtils/arrayUtils';
const api = buildService('/project_elster_details/{id}/shareholders', {
  only: ['all', 'get', 'update', 'delete', 'create']
});
const shareholdersService = {
  useFetchAll: function (projectElsterDetailId, setListLoading) {
    let fetchImmediately = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    const [shareholders, setShareholders, fetchShareholders] = serviceMethods.useFetch({
      callback: useCallback(async () => {
        var _response$shareholder;
        const response = await api.all(projectElsterDetailId);
        return (_response$shareholder = response === null || response === void 0 ? void 0 : response.shareholders) !== null && _response$shareholder !== void 0 ? _response$shareholder : response;
      }, [projectElsterDetailId]),
      setLoading: setListLoading,
      fetchImmediately
    });
    return [shareholders, setShareholders, fetchShareholders];
  },
  useGet: setDetailLoading => {
    const [shareholder, setShareholder, fetchShareholder] = serviceMethods.useFetch({
      callback: useCallback(async _ref => {
        var _response$shareholder2;
        let {
          projectElsterDetailId,
          shareholderId
        } = _ref;
        const response = await api.get(projectElsterDetailId, shareholderId);
        return (_response$shareholder2 = response === null || response === void 0 ? void 0 : response.shareholder) !== null && _response$shareholder2 !== void 0 ? _response$shareholder2 : response;
      }, []),
      setLoading: setDetailLoading,
      fetchImmediately: false,
      initialStateValue: null
    });
    return [shareholder, setShareholder, fetchShareholder];
  },
  useUpdate: (projectElsterDetailId, setDetailLoading, setShareholders, setShareholder) => {
    const updateShareholder = serviceMethods.useUpdate({
      callback: useCallback(async shareholder => {
        const updatedShareholder = await api.update(projectElsterDetailId, shareholder.id, {
          shareholder
        });
        if (setShareholders) {
          setShareholders(replaceInArray(s => s.id === updatedShareholder.id, updatedShareholder));
        }
        if (setShareholder) {
          setShareholder(updatedShareholder);
        }
        return updatedShareholder;
      }, [projectElsterDetailId, setShareholders, setShareholder]),
      setLoading: setDetailLoading
    });
    return [updateShareholder];
  },
  useCreate: (projectElsterDetailId, setDetailLoading, setShareholders, setShareholder, setSelectedShareholder) => {
    const createShareholder = serviceMethods.useCreate({
      callback: useCallback(async shareholder => {
        const newShareholder = await api.create(projectElsterDetailId, {
          shareholder
        });
        if (setShareholders) {
          setShareholders(shareholders => [...shareholders, newShareholder]);
        }
        if (setShareholder) {
          setShareholder(newShareholder);
        }
        if (setSelectedShareholder) {
          setSelectedShareholder(newShareholder.id);
        }
        return newShareholder;
      }, [projectElsterDetailId, setShareholders, setShareholder, setSelectedShareholder]),
      setLoading: setDetailLoading
    });
    return [createShareholder];
  },
  useDelete: (projectElsterDetailId, setListLoading, setShareholders, setSelectedShareholder) => {
    const deleteShareholder = serviceMethods.useDelete({
      callback: useCallback(async shareholder => {
        await api.delete(projectElsterDetailId, shareholder.id);
        if (setShareholders) {
          setShareholders(shareholders => shareholders.filter(s => s.id !== shareholder.id));
        }
        if (setSelectedShareholder) {
          setSelectedShareholder(null);
        }
      }, [projectElsterDetailId, setShareholders, setSelectedShareholder]),
      setLoading: setListLoading
    });
    return [deleteShareholder];
  }
};
shareholdersService.useCrud = function (projectElsterDetailId, setListLoading, setDetailLoading, setSelectedShareholder) {
  let fetchImmediately = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  const [shareholders, setShareholders, fetchShareholders] = shareholdersService.useFetchAll(projectElsterDetailId, setListLoading, fetchImmediately);
  const [shareholder, setShareholder, fetchShareholder] = shareholdersService.useGet(setDetailLoading);
  const [updateShareholder] = shareholdersService.useUpdate(projectElsterDetailId, setDetailLoading, setShareholders, setShareholder);
  const [createShareholder] = shareholdersService.useCreate(projectElsterDetailId, setDetailLoading, setShareholders, setShareholder, setSelectedShareholder);
  const [deleteShareholder] = shareholdersService.useDelete(projectElsterDetailId, setListLoading, setShareholders, setSelectedShareholder);
  return {
    shareholders,
    setShareholders,
    fetchShareholders,
    shareholder,
    setShareholder,
    fetchShareholder,
    updateShareholder,
    createShareholder,
    deleteShareholder
  };
};
export default shareholdersService;